export const SECTORS = ["All", "Tech & AI", "Finance", "Healthcare", "Energy", "Defense", "Consumer", "Dynamic"];

// Loading-screen visual system
export const BG    = "#050814";
export const CARD  = "#0a1020";
export const CARD2 = "#0d1728";
export const CARD3 = "#13213a";
export const BD    = "#1b3154";
export const TX    = "#d9e7fb";
export const TX2   = "#7890b2";
export const GR    = "#00e676";
export const BL    = "#38bdf8";
export const YL    = "#f4c542";
export const RD    = "#ef5350";
export const PU    = "#9d8cff";
